import { Phone } from "lucide-react";
import { useContent } from "@/context/ContentContext";

/**
 * Pływający przycisk „Zadzwoń teraz" — widoczny tylko na mobilnych (sm:hidden).
 * Odpala domyślną aplikację telefonu z numerem infolinii.
 * Włącz/wyłącz + zmień etykietę z panelu admina.
 */
export default function FloatingCallButton() {
  const { brand } = useContent();
  const cfg = brand?.floating_call || {};
  const phone = brand?.contact?.phone || "";
  if (!cfg.enabled || !phone) return null;

  const digits = phone.replace(/[^\d+]/g, "");
  const label = cfg.label || "Zadzwoń teraz";

  return (
    <a
      data-testid="floating-call-btn"
      href={`tel:${digits}`}
      aria-label={label}
      className="sm:hidden fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-[#dc2626] hover:bg-[#ef4444] text-white font-bold px-5 py-4 rounded-full shadow-2xl shadow-[#dc2626]/40 transition active:scale-95"
      style={{ animation: "rm-pulse 2.4s ease-in-out infinite" }}
    >
      <Phone size={20} className="animate-pulse" />
      <span className="text-sm">{label}</span>
    </a>
  );
}
